import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import StepBuilder, { Steps, Step } from '../../../../components/StepBuilder';
import FindDelivery from './scenes/FindDelivery';
import Authenticate from './scenes/Authenticate';
import Files from './scenes/Files';
import ProgressMeter from './components/Progress';
import DeliveriesLayout from '../../../../components/Layout/DeliveriesLayout';

const Deliveries = () => {
  const { t } = useTranslation('deliveries');
  const userCanUploadFiles = useSelector(state => state.deliveries.userCanUploadFiles);
  
  const stepNames = [t('stepNames1'), t('stepNames2'), t('stepNames3')];
  const stepInfo = [t('stepInfo1'), t('stepInfo2'), t('stepInfo3')];

  return (
    <DeliveriesLayout title={t('page-title')} userCanUploadFiles={userCanUploadFiles}>
      <div className="box">
        <StepBuilder totalSteps={3}>
          <ProgressMeter stepInfo={stepInfo} stepNames={stepNames} />
          
          <Steps>
            <Step component={FindDelivery} />
            <Step component={Authenticate} />
            <Step component={Files} />
          </Steps>
        </StepBuilder>
      </div>
    </DeliveriesLayout>
  );
};

export default Deliveries;